// Panel de consolidación de pedidos por proveedor
// Agrupa automáticamente los ítems de todos los pedidos confirmados por proveedor
import { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase/config";

const G={bg:"#FAF9F7",s1:"#FFFFFF",s2:"#F4F2EF",border:"#E2DFD9",black:"#1C1917",off:"#3D3830",muted:"#8C8078",orange:"#D2611A",green:"#16A34A",red:"#DC2626",blue:"#2563EB",amber:"#D97706",sans:"'Outfit','Helvetica Neue',Arial,sans-serif",mono:"'IBM Plex Mono',monospace"};
const O="#D2611A";

export default function AdminPedidosProveedor(){
  const[pedidos,setPedidos]=useState([]);
  const[proveedores,setProveedores]=useState([]);
  const[productos,setProductos]=useState([]);
  const[loading,setLoading]=useState(true);
  const[provSelec,setProvSelec]=useState(null);
  const[estados,setEstados]=useState(["confirmado","produccion","embarque"]);

  useEffect(()=>{
    Promise.all([
      getDocs(collection(db,"pedidos")).catch(()=>({docs:[]})),
      getDocs(collection(db,"proveedores")).catch(()=>({docs:[]})),
      getDocs(collection(db,"productos")).catch(()=>({docs:[]})),
    ]).then(([pSnap,pvSnap,prSnap])=>{
      setPedidos(pSnap.docs.map(d=>({id:d.id,...d.data()})));
      setProveedores(pvSnap.docs.map(d=>({id:d.id,...d.data()})));
      setProductos(prSnap.docs.map(d=>({id:d.id,...d.data()})));
      setLoading(false);
    });
  },[]);

  // Consolidar items por proveedor
  const consolidar=()=>{
    const pedidosFiltrados=pedidos.filter(p=>estados.includes(p.estado));
    const mapa={}; // { proveedorId: { proveedor, items: [{producto,cantidad,pedidoId,compradorNombre}] } }

    pedidosFiltrados.forEach(pedido=>{
      (pedido.items||[]).forEach(item=>{
        const prod=productos.find(p=>p.id===item.productoId);
        if(!prod)return;
        const provId=prod.proveedor_id||"sin-proveedor";
        const provNombre=prod.proveedor_nombre||"Sin proveedor asignado";
        if(!mapa[provId]) mapa[provId]={id:provId,nombre:provNombre,items:[]};
        // Buscar si ya hay ese producto
        const existing=mapa[provId].items.find(i=>i.productoId===item.productoId);
        if(existing){
          existing.cantidad+=parseFloat(item.cantidad)||0;
          existing.pedidos.push({pedidoId:pedido.id,compradorNombre:pedido.compradorNombre,cantidad:item.cantidad});
        } else {
          mapa[provId].items.push({
            productoId:item.productoId,
            productoNombre:prod.nombre||item.productoNombre,
            rubro:prod.rubro,
            sku:prod.sku,
            unidad:prod.unidad||"u",
            cantidad:parseFloat(item.cantidad)||0,
            precio_unit:item.precio_unit||prod.precio_venta||0,
            pedidos:[{pedidoId:pedido.id,compradorNombre:pedido.compradorNombre,cantidad:item.cantidad}],
          });
        }
      });
    });
    return Object.values(mapa);
  };

  const grupos=consolidar();
  const exportarWA=(grupo)=>{
    const prov=proveedores.find(p=>p.id===grupo.id);
    const lines=grupo.items.map(i=>`• ${i.productoNombre} (${i.sku||"—"}): ${i.cantidad} ${i.unidad}`).join("\n");
    const msg=`Hola ${prov?.contacto||""},\n\nConsolidado de pedidos:\n${lines}\n\nSaludos, WINARQ`;
    window.open(`https://wa.me/${prov?.wechat||""}?text=${encodeURIComponent(msg)}`,"_blank");
  };

  const exportarEmail=(grupo)=>{
    const prov=proveedores.find(p=>p.id===grupo.id);
    const body=grupo.items.map(i=>`${i.productoNombre} (${i.sku||"—"}): ${i.cantidad} ${i.unidad}`).join("\n");
    window.location.href=`mailto:${prov?.email||""}?subject=Pedido consolidado WINARQ&body=${encodeURIComponent(body)}`;
  };

  return(
    <div>
      <div style={{fontFamily:G.sans,fontSize:22,color:G.black,fontWeight:700,marginBottom:4}}>Pedidos por proveedor</div>
      <div style={{fontFamily:G.sans,fontSize:11,color:G.muted,marginBottom:20}}>
        Consolidación automática de ítems por proveedor. Invisible para clientes.
      </div>

      {/* Filtro de estados */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:20}}>
        <div style={{fontFamily:G.sans,fontSize:11,color:G.muted,alignSelf:"center"}}>Incluir estados:</div>
        {["cotizacion","confirmado","produccion","embarque","aduana","entregado"].map(e=>(
          <button key={e} onClick={()=>setEstados(prev=>prev.includes(e)?prev.filter(x=>x!==e):[...prev,e])}
            style={{padding:"4px 12px",fontFamily:G.sans,fontSize:9,letterSpacing:1.5,textTransform:"uppercase",background:estados.includes(e)?G.orange:"transparent",color:estados.includes(e)?"#fff":G.muted,border:`1.5px solid ${estados.includes(e)?G.orange:G.border}`,cursor:"pointer",fontWeight:estados.includes(e)?700:500}}>
            {e}
          </button>
        ))}
      </div>

      {loading?(
        <div style={{padding:40,textAlign:"center",fontFamily:G.sans,fontSize:12,color:G.muted}}>Cargando...</div>
      ):grupos.length===0?(
        <div style={{padding:40,textAlign:"center",background:G.s1,border:`1px solid ${G.border}`}}>
          <div style={{fontFamily:G.sans,fontSize:13,color:G.muted}}>Sin pedidos en los estados seleccionados.</div>
        </div>
      ):(
        grupos.map(grupo=>{
          const prov=proveedores.find(p=>p.id===grupo.id);
          const totalUSD=grupo.items.reduce((s,i)=>s+(i.cantidad*(i.precio_unit||0)),0);
          return(
            <div key={grupo.id} style={{background:G.s1,border:`1.5px solid ${G.border}`,marginBottom:20}}>
              {/* Header proveedor */}
              <div style={{background:grupo.id==="sin-proveedor"?G.s2:G.black,padding:"12px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
                <div>
                  <div style={{fontFamily:G.sans,fontSize:15,fontWeight:700,color:grupo.id==="sin-proveedor"?G.muted:"#fff"}}>{grupo.nombre}</div>
                  {prov&&<div style={{fontFamily:G.mono,fontSize:9,color:"rgba(255,255,255,.5)",marginTop:2}}>{prov.contacto} · {prov.ciudad} · {prov.wechat}</div>}
                </div>
                <div style={{display:"flex",gap:8}}>
                  {prov?.wechat&&(
                    <button onClick={()=>exportarWA(grupo)} style={{padding:"7px 14px",background:G.green,color:"#fff",fontFamily:G.sans,fontSize:9,letterSpacing:1.5,textTransform:"uppercase",border:"none",cursor:"pointer",fontWeight:700}}>
                      ↗ Enviar por WA
                    </button>
                  )}
                  {prov?.email&&(
                    <button onClick={()=>exportarEmail(grupo)} style={{padding:"7px 14px",background:"transparent",color:O,fontFamily:G.sans,fontSize:9,letterSpacing:1.5,textTransform:"uppercase",border:`1.5px solid ${O}`,cursor:"pointer",fontWeight:700}}>
                      ✉ Email
                    </button>
                  )}
                </div>
              </div>

              {/* Tabla de items consolidados */}
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead>
                  <tr style={{background:G.s2}}>
                    {["Producto","SKU","Rubro","Cant. total","Precio unit.","Subtotal","Pedidos"].map(h=>(
                      <th key={h} style={{fontFamily:G.sans,fontSize:8,letterSpacing:1.5,color:G.muted,textTransform:"uppercase",fontWeight:600,padding:"7px 12px",textAlign:"left",borderBottom:`1px solid ${G.border}`}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {grupo.items.map((item,i)=>(
                    <tr key={i} style={{borderBottom:`1px solid ${G.border}`}}>
                      <td style={{fontFamily:G.sans,fontSize:12,color:G.black,padding:"9px 12px",fontWeight:600}}>{item.productoNombre}</td>
                      <td style={{fontFamily:G.mono,fontSize:10,color:G.muted,padding:"9px 12px"}}>{item.sku||"—"}</td>
                      <td style={{fontFamily:G.sans,fontSize:10,color:O,padding:"9px 12px"}}>{item.rubro}</td>
                      <td style={{fontFamily:G.mono,fontSize:13,color:G.black,padding:"9px 12px",fontWeight:700}}>{item.cantidad} {item.unidad}</td>
                      <td style={{fontFamily:G.mono,fontSize:11,color:G.off,padding:"9px 12px"}}>USD {(item.precio_unit||0).toFixed(2)}</td>
                      <td style={{fontFamily:G.mono,fontSize:12,color:O,padding:"9px 12px",fontWeight:700}}>USD {(item.cantidad*(item.precio_unit||0)).toFixed(2)}</td>
                      <td style={{padding:"9px 12px"}}>
                        {item.pedidos.map((p,j)=>(
                          <div key={j} style={{fontFamily:G.sans,fontSize:9,color:G.muted,marginBottom:1}}>
                            {p.compradorNombre} ({p.cantidad} {item.unidad})
                          </div>
                        ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{background:"#FEF3E8"}}>
                    <td colSpan={5} style={{fontFamily:G.sans,fontSize:11,color:G.muted,padding:"9px 12px",fontWeight:600}}>Total consolidado</td>
                    <td style={{fontFamily:G.mono,fontSize:14,color:O,padding:"9px 12px",fontWeight:700}}>USD {totalUSD.toFixed(2)}</td>
                    <td/>
                  </tr>
                </tfoot>
              </table>
            </div>
          );
        })
      )}
    </div>
  );
}
